import {
  Box,
  Button,
  Flex,
  HStack,
  InputGroup,
  Input,
  InputLeftElement,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { RiAddFill, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { openCreateVideos } from "../../../modules/admin-modules/models/Actions";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { createVideoVouchersRequest } from "../../../modules/admin-modules/videos/Actions";

const SearchBar = ({
  setAdd,
  setSelectedData,
  selectedSectionIds,
  setSelectedSectionIds,
  videoCount,
}) => {
  const dispatch = useDispatch();
  const sections = useSelector((state) => state.adminSections.sections);

  const sectionsOptions = sections?.map((section) => ({
    value: section.id,
    label: section.name,
  }));

  const selectedSections = sectionsOptions?.filter((option) =>
    selectedSectionIds.some(
      (sectionId) => String(sectionId) === String(option.value)
    )
  );
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "white",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  return (
    <VStack w="100%" my={{ base: "50px", md: "30px" }}>
      <Flex
        alignItems="center"
        w="100%"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Text
          fontSize="24px"
          fontWeight="600"
          color="main_1"
          width={{ base: "100%", md: "20%" }}
          mb={{ base: "10px", md: 0 }}
        >
          الفيديوهات
        </Text>

        <Flex alignItems="center" flexWrap="wrap" gap={2}>
          <Button
            borderRadius="16px"
            leftIcon={<RiAddFill />}
            mx="8px"
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              setAdd(true);
              dispatch(openCreateVideos());
            }}
          >
            إضافة فيديو
          </Button>
          <Button
            borderRadius="16px"
            mx="8px"
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              dispatch(createVideoVouchersRequest());
            }}
          >
            create video vouchers
          </Button>
          <Box display={{ base: "none", md: "block" }}>
            <LogoutMenu />
          </Box>{" "}
        </Flex>
      </Flex>
      <Text w="100%" fontSize="20px" textAlign="right">
        {" "}
        عدد الفيديوهات: {videoCount}
      </Text>
      <Box w="100%" maxW={{ base: "100%", md: "400px" }} alignSelf="flex-end">
        <Select
          options={sectionsOptions}
          value={selectedSections}
          isMulti
          onChange={(data) => {
            setSelectedSectionIds(data?.map((item) => item.value) || []);
          }}
          styles={colourStyles}
          placeholder="تصفية حسب القسم"
        />
      </Box>
    </VStack>
  );
};

export default SearchBar;
